import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';

function UndoDispute() {
  const { t } = useTranslate();

  return (
    <Button disabled type="text" size="small">
      {t('撤销争议')}
    </Button>
  );
}

export default UndoDispute;
